import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ wait: _ctx.isLoginProcessing })
  }, [
    (_ctx.isLoggedIn && !_ctx.iconBtn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { path: '/account' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              button: "",
              lines: "none",
              class: "bold view-account"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" View Account ")
                  ])),
                  _: 1,
                  __: [0]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_ion_button, {
            key: 1,
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: { path: '/account', query: { utm_medium: 'web', utm_source: 'nav' } } }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: require('@/assets/account-loggedin-icon.svg'),
                    color: "medium",
                    class: "mb-4",
                    style: {"font-size":"30px"},
                    "data-cy": "desktop-account-icon"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_button, {
            key: 2,
            fill: "clear",
            disabled: _ctx.isLoginProcessing
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: '/login?redirect=/' }, {
                default: _withCtx(() => [
                  (_ctx.iconBtn)
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: require('@/assets/account-icon.svg'),
                        color: "medium",
                        style: {"font-size":"25px"},
                        "data-cy": "desktop-account-icon"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]))
  ], 2))
}